// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import enquiryReducer from './slices/enquirySlice';
import aboutReducer from './slices/aboutSlice';
import resultReducer from './slices/resultSlice';
import eventReducer from './slices/eventSlice';
import eventImagesReducer from './slices/eventImagesSlice';
import studentLifeReducer from './slices/studentLifeSlice';
import studentLifeImagesReducer from './slices/studentLifeImagesSlice';
import userReducer from './slices/userSlice';
import notificationReducer from './slices/notificationSlice';
import uiReducer from './slices/uiSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    enquiry: enquiryReducer,
    about: aboutReducer,
    result: resultReducer,
    event: eventReducer,
    eventImages: eventImagesReducer,
    studentLife: studentLifeReducer,
    studentLifeImages: studentLifeImagesReducer,
    users: userReducer,
    notification: notificationReducer,
    ui: uiReducer,
  },
});

export default store;